import { Card } from '@consumidor-positivo/aurora';
import { SHAnnuity, SHHighlight } from '../../../../services/sortingHat/types';
import { getConditionalAnnuity } from '../../../../helpers/getConditionalAnnuity';

type HighlightCardOfferProps = {
  highlights: SHHighlight[] | undefined;
  annuity?: SHAnnuity;
};

export const HighlightsOfferCard = ({ highlights, annuity }: HighlightCardOfferProps) => {
  if (!highlights || highlights.length === 0) {
    return null;
  }

  return (
    <Card.Emphasis
      height={111}
      content={highlights.map((highlight, index) => ({
        title: (annuity && index === 0) ? 'Anuidade' : highlight.title || '',
        description: (annuity && index === 0) ? getConditionalAnnuity(annuity) : highlight.value || '',
      }))}
    />
  );
};
